import { formatVariation } from "@/utils/percentage";

// Variaciones de la tabla del tab Dashboard (docs/decisiones/37-dashboard-reporte-financiero.md).
//
// El backend manda cada delta como fracción y, por fila, la `polarity`: "up"
// cuando subir es favorable (ventas, márgenes, resultados) y "down" cuando
// lo favorable es bajar (costos, gastos, Gastos Totales %). El tono de color
// sale de cruzar el signo con la polaridad — en el resto del reporte un alza
// se pinta verde siempre, y acá «Costos +127 %» tiene que verse en rojo.
//
// Las filas de monto llevan variación relativa (`formatVariation`, entero
// half-up); las filas % llevan la diferencia entre los dos porcentajes escrita
// con «%», como en el mockup (88 % → 86 % = «-2%»). Steve lo confirmó con
// datos reales el 2026-10-06 (D4 de §37): no es variación relativa ni «pp».

export const TONE_FAVORABLE = "favorable";
export const TONE_UNFAVORABLE = "unfavorable";
export const TONE_NEUTRAL = "neutral";

export const EMPTY_VALUE = "—";

export function deltaTone(delta, polarity) {
    if (delta == null || delta === 0) return TONE_NEUTRAL;
    const isUp = delta > 0;
    const upIsGood = polarity !== "down";
    return isUp === upIsGood ? TONE_FAVORABLE : TONE_UNFAVORABLE;
}

export function formatDelta(delta, { isMoney = true } = {}) {
    if (delta == null) return EMPTY_VALUE;
    if (isMoney) return formatVariation(delta, { withSign: true, dash: EMPTY_VALUE });
    const points = Math.round(delta * 100);
    if (points === 0) return "0%";
    return `${points > 0 ? "+" : "-"}${Math.abs(points)}%`;
}
